module.exports = __webpack_public_path__ + "static/mannobackground-dec9f023ee3028f195adb01a2b9918c3.png";